import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "cart-menu-line" };
const _hoisted_2 = { class: "flex justify-between items-start gap-2" };
const _hoisted_3 = { class: "flex-1 min-w-0" };
const _hoisted_4 = { class: "font-semibold text-gray-900 truncate" };
const _hoisted_5 = { class: "text-sm text-gray-600 mt-1" };
const _hoisted_6 = { class: "font-semibold text-gray-900 whitespace-nowrap" };
const _hoisted_7 = {
    key: 0,
    class: "mt-2 pl-3 border-l-2 border-gray-200 space-y-2"
};
import { ref, computed } from 'vue';
import MenuComponentLine from '@shared/components/menu/MenuComponentLine.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CartMenuLine',
    props: {
        item: {}
    },
    setup(__props) {
        const props = __props;
        const expanded = ref(true);
        const lineTotalCent = computed(() => props.item.totalPriceCent ?? Math.round(props.item.totalPrice * 100));
        // Stückpreis aus dem (serverautoritativen) Gesamtpreis ableiten, damit
        // „Anzahl × Stückpreis = Gesamtpreis" stimmt – inkl. Komponenten-Aufpreise.
        const unitPriceCent = computed(() => {
            const qty = props.item.quantity || 1;
            return Math.round(lineTotalCent.value / qty);
        });
        const formatPrice = (cent) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cent / 100);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, " Menü: " + _toDisplayString(_ctx.item.menuItem.name), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.item.quantity) + "× " + _toDisplayString(formatPrice(unitPriceCent.value)), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(formatPrice(lineTotalCent.value)), 1 /* TEXT */)
                ]),
                (expanded.value && _ctx.item.componentConfigs?.length)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.componentConfigs, (comp, idx) => {
                            return (_openBlock(), _createBlock(MenuComponentLine, {
                                key: `${comp.productId}-${idx}`,
                                comp: comp
                            }, null, 8 /* PROPS */, ["comp"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]))
                    : _createCommentVNode("v-if", true),
                (_ctx.item.componentConfigs?.length)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "text-xs text-primary mt-1",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (expanded.value = !expanded.value), ["stop"]))
                    }, _toDisplayString(expanded.value ? 'Komponenten ausblenden' : 'Komponenten anzeigen'), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
